var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 21,
    viewBox: "0 0 29 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.34023 0.579987C1.63523 0.579987 0.240234 1.97499 0.240234 3.67999V17.32C0.240234 19.025 1.63523 20.42 3.34023 20.42H25.6602C27.3652 20.42 28.7602 19.025 28.7602 17.32V3.67999C28.7602 1.97499 27.3652 0.579987 25.6602 0.579987H3.34023ZM3.34023 1.81999H25.6602C26.6944 1.81999 27.5202 2.64585 27.5202 3.67999V4.91999H1.48023V3.67999C1.48023 2.64585 2.30609 1.81999 3.34023 1.81999ZM1.48023 8.01999H27.5202V17.32C27.5202 18.3541 26.6944 19.18 25.6602 19.18H3.34023C2.30609 19.18 1.48023 18.3541 1.48023 17.32V8.01999ZM4.58023 9.87999V11.12H14.5002V9.87999H4.58023Z",
    fill: "#323232"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.9a46b9b7ea59ddba87114817ba19dc0b.svg";
export { ForwardRef as ReactComponent };